import React from 'react';
import { spacer16, spacer56 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { ParentCategory } from 'lib/sanity/types';
import { PageContainerWidth } from 'components/PageContainer';
import { UbiHomePage } from 'utils/ubi/pages/useUbiHome';
import { useTranslation } from 'providers/translations/TranslationProvider';

import CategoryCard from './CategoryCard';

const Grid = styled.div`
  padding-top: ${spacer16};
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: ${spacer16};
  justify-items: stretch;
  margin-bottom: ${spacer56};

  @media (min-width: ${PageContainerWidth}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
`;

export interface CategoryCardsProps {
  categories: ParentCategory[];
  ubi: UbiHomePage;
}

const CategoryCardSection = ({ categories, ubi }: CategoryCardsProps) => {
  const { t } = useTranslation();
  return (
    <Grid data-testid="categoriesContainer" role="list" aria-label={t('categories')}>
      {categories.map((category, index) => (
        <CategoryCard category={category} key={category.title} index={index} ubi={ubi} />
      ))}
    </Grid>
  );
};

export default CategoryCardSection;
